/* INICIO FAVORITO */
window.triggerfav = (id_botao, imo_codigo) =>{

	if(id_botao){

		let like = '/jnh/icones/like.png';
		let unlike = '/jnh/icones/unlike.png';
		if(Boss.getById(id_botao).querySelector("IMG").getAttribute("src") == like){

			confirmarremoverfav(Boss.getById(id_botao), imo_codigo);
		}else if(Boss.getById(id_botao).querySelector("IMG").getAttribute("src") == unlike){
			
			addfav(Boss.getById(id_botao), imo_codigo);
		}
	}
}
window.triggerbtnfav = (id_botao, acao) => {

	if(id_botao){

		let like = '/jnh/icones/like.png';
		let unlike = '/jnh/icones/unlike.png';
		if(acao === 1){
			id_botao.querySelector("IMG").src = like;
		}
		if(acao === 2){
			id_botao.querySelector("IMG").src = unlike;
		}
	}
}
window.addfav = (id_botao, imo_codigo) => {

	/*
		Verificar se o site tem Login por Facebook
		Verificar se o usuário está logado no Facebook
		Favoritar ..
	*/
	if(sessionStorage.getItem('login') == null || sessionStorage.getItem('login') == 'false'){

		if(typeof(Google) !== 'undefined'){
			const sdasasfsaf = new Google(id_cliente);
		}
	
		var html = `
			<h1>Logar com</h1>
			<button class="b b-secondary" onclick="fb_login('${id_botao.id}', ${imo_codigo});">Facebook</button>
			<div class="site-space-1"></div>
			<input type="hidden" id="id_do_imo_codigo" value="${imo_codigo}" />
			<input type="hidden" id="id_do_id_botao" value="${id_botao.id}" />
			<div class="g-signin2" data-onsuccess="googleonline" data-theme="dark"></div>
			<div class="site-space-3"></div>
			<script>
				window.googleonline = data => {
					var profile = data.getBasicProfile();

					login.google({
						nome: profile.getName(),
						email: profile.getEmail(),
						id: profile.getId(),
						imagem: profile.getImageUrl(),
					})

					let id_botao = id_do_imo_codigo.value;
					let imo_codigo = id_do_id_botao.value;
					triggerbtnfav(Boss.getById(id_botao), 1);
							
					Boss.ajax({
						url: '/favoritos/add',
						data: {'imo_codigo': imo_codigo, 'login': login.data()},
						dataType: 'json',
						done: rtn => {}
					});
					
					Boss.dialog.close();
				};
				window.google_login = (id_botao, imo_codigo)  => {

						triggerbtnfav(Boss.getById(id_botao), 1);
							
						Boss.ajax({
							url: '/favoritos/add',
							data: {'imo_codigo': imo_codigo, 'login': login.data()},
							dataType: 'json',
							done: rtn => {}
						});

						Boss.dialog.close();
				};

				window.fb_login = (id_botao, imo_codigo) => {
					
					const FB = new Facebook();

					(async () => {
						await FB.init({
							appId: appId,
							autoLogAppEvents: true,
							xfbml: true,
							version: 'v8.0',
						});
						
						let authResponse = await FB.getLoginStatus();
						if (authResponse.status === 'unknown') {
							authResponse = await FB.login();
						}
						const me = await FB.me();

						if(typeof(me.name) !== 'undefined' && typeof(me.id) !== 'undefined' && me.name !== '' && me.id !== ''){

							login.facebook({
								nome: me.name,
								email: me.email,
								id: me.id,
								imagem: '',
							});

							triggerbtnfav(Boss.getById(id_botao), 1);
							
							Boss.ajax({
								url: '/favoritos/add',
								data: {'imo_codigo': imo_codigo, 'login': login.data()},
								dataType: 'json',
								done: rtn => {}
							});

							Boss.dialog.close();
						}
					})();
				};
			</script>
		`;
		
		Boss.dialog.open({
			html: html,
			visible: true,
			close: true
		});
	}else{

		triggerbtnfav(id_botao, 1);

		Boss.ajax({
			url: '/favoritos/add',
			data: {'imo_codigo': imo_codigo, 'login': login.data()},
			dataType: 'json',
			done: rtn => {}
		});
	}
}

window.confirmarremoverfav = (id_botao, imo_codigo) => {

	triggerbtnfav(id_botao, 2);
	Boss.ajax({
		url: '/favoritos/remover',
		data: {'imo_codigo': imo_codigo},
		dataType: 'json',
		done: rtn => {}
	});
}
/* FIM FAVORITO */